<template>
  <svg class='close' viewBox="0 0 20 20">
    <line x1="1" y1="1" x2="19" y2="19" />
    <line x1="19" y1="1" x2="1" y2="19" />
  </svg>
</template>
